export const NOTIFICATION_UNREAD_BASELINE_SYNC_EVENT = "notifications:unread-count-baseline-sync";

export function syncNotificationUnreadCountBaseline(count: number): void {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(NOTIFICATION_UNREAD_BASELINE_SYNC_EVENT, {
      detail: { count },
    }),
  );
}
